var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapSkeleton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 637,
    viewBox: "0 0 1366 637",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8707_392358)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 1371,
    height: 640,
    fill: "#DFE2E7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: 235.605,
    width: 628.755,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-27.6314 -120 235.605)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -54,
    y: 416.605,
    width: 1052.4,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-27.6314 -54 416.605)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19,
    y: 605.082,
    width: 1417.02,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-27.6314 -19 605.082)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 735.189,
    width: 1417.02,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-27.6314 196 735.189)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406,
    y: 868.189,
    width: 1417.02,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-27.6314 406 868.189)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1914.57,
    y: 862.024,
    width: 1417.02,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-126.939 1914.57 862.024)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1383.57,
    y: 894.024,
    width: 1417.02,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-126.939 1383.57 894.024)",
    fill: "#F3F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.573,
    y: 1092.02,
    width: 1417.02,
    height: 25.6714,
    rx: 4,
    transform: "rotate(-126.939 663.573 1092.02)",
    fill: "#F3F4F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8707_392358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1371,
    height: 640,
    fill: "white",
    transform: "translate(-1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapSkeleton);
export default __webpack_public_path__ + "static/media/map-skeleton.2a783d92ba38b677c6c55082b86f8408.svg";
export { ForwardRef as ReactComponent };